/**
 * @file: MorningCheck.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 晨检机平台配置
 */
import request from '@/utils/request'

/**
 * 新增晨检机平台配置
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function morningCheckAdd(data) {
  return request({
    type: 'device',
    url: 'morning/check/add',
    method: 'post',
    data
  })
}

/**
 * 删除晨检机平台配置
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function morningCheckDelete(data) {
  return request({
    type: 'device',
    url: 'morning/check/delete',
    method: 'post',
    data
  })
}

/**
 * 获取晨检机平台配置详情
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function morningCheckGet(data) {
  return request({
    type: 'device',
    url: 'morning/check/get',
    method: 'post',
    data
  })
}

/**
 * 晨检机平台配置列表(分页)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function morningCheckPageListGet(data) {
  return request({
    type: 'device',
    url: 'morning/check/page/list/get',
    method: 'post',
    data
  })
}

/**
 * 修改晨检机平台配置
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function morningCheckUpdate(data) {
  return request({
    type: 'device',
    url: 'morning/check/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/MorningCheck.js